$(window).scroll(function() {
  if ($(this).scrollTop() > 50) {
    $('html').addClass("header_sticky");
  }
  else {
    $('html').removeClass("header_sticky");
  }
});
$(document).ready(function() {
  if ($(this).scrollTop() > 50) {
    $('html').addClass("header_sticky");
  }
});
$(window).on('load', function(){
  $(".cart__footer-wrapper,.cart_itme").wrapAll( "<div class='cart_page_wrap_sec'><div class='container'><div class='cart_page_inner' /></div></div>");
  
  $('.menu-drawer__close').click(function(){
    $('.menu-drawer-container').removeClass('menu-opening');
    $('.menu-drawer-container .header__icon').attr('aria-expanded','false');
    $('.menu-drawer-container').removeAttr('open');
    $('.section-header').removeClass('menu-open');
    $('body').removeClass('overflow-hidden-desktop');
  })
})
  
// Size Chart
$(window).on('load', function(){
  
  $('.size_cate_cloth ul').fadeOut();
  $('.size_cate li .title_tab').click(function(){
       var step1 = $(this).parents('.size_cate').attr('dt-id');
        $(this).parents('.sizeguide_display_area').prev('ul').find('li:first-child a').attr('dt-href',step1);
      $(this).parents('.sizeguide_display_area').prev('ul').find('li').removeClass('current');
        $(this).parents('.sizeguide_display_area').prev('ul').find('li:nth-child(2)').addClass('current');
       $('.size_cate li').removeClass('active');
        $(this).parent().addClass('active');
        $(this).parents('.size_cate').fadeOut(180);
        $('.size_cate_cloth ul').hide();
        $('.size_cate_cloth').show();
        var data= $(this).parents('.active').find('.product_accordion_title').text();
        $('.size_title p span').remove();
        $('.size_title p').append('<span>'+ data +'</span>');
        
        var activeTab = $(this).parent().attr('data-id');
        $(this).parents('.size_cate ').next().find('.pro_cat_cloth_items_list[gt-2-id="' + activeTab + '"]').fadeIn(210);
        return false;
  });
  
  $('.sizeguide-step3').fadeOut();
  $('.size_cate_cloth li .title_tab').click(function(){
        var step1 = $(this).parents('.size_cate_cloth').attr('dt-id');
        $(this).parents('.sizeguide_display_area').prev('ul').find('li:nth-child(2) a').attr('dt-href',step1);
        $(this).parents('.sizeguide_display_area').prev('ul').find('li').removeClass('current');
        $(this).parents('.sizeguide_display_area').prev('ul').find('li:last-child').addClass('current');
       $('.size_cate li').removeClass('active');
        $(this).parent().addClass('active');
        $(this).parents('.size_cate_cloth').fadeOut(180);
        $('.sizeguide-step3').hide();
        $('.Size_gideline_data ').show();
        var data= $(this).find('.product_accordion_title').text();
        $('.size_title p span').next().remove();
        $('.size_title p ').append('<span>'+ data +'</span>');
    
        var activeTab = $(this).parent().attr('data-tag');
        $(this).parents('.size_cate_cloth').next().find('.sizeguide-step3[size-id="' + activeTab + '"]').fadeIn(210);
        return false;
  });

  $('.product-popup-modal__opener button').click(function(){
    $('html').addClass('size_popup');
    $('body').addClass('overflow-hidden');
    var modal = $(this).parent().attr('data-modal');
      console.log(modal);
      $(modal).attr('open','');
      $('.size_cate_cloth ul').fadeOut(20);
      $('.sizeguide-step3').fadeOut(20);
      $('.size_cate,.size_cate_cloth').fadeIn(40);
  });
  $('.product-popup-modal .product-popup-modal__toggle ').click(function(){
    $('html').removeClass('size_popup');
    $('body').removeClass('overflow-hidden');
     $('.product-popup-modal').removeAttr('open');
  })
  $('body .sizeguide-stepper li:nth-child(2) a').click(function(e){
     $('.size_title p span').next().remove();
  });
  $('body .sizeguide-stepper li:first-child a').click(function(e){
     $('.size_title p span').remove();
 });
  
  $('.field-wrapper .input-radio').on('change', function() { 
        var val = $(this).attr('value'); 
        $(this).parents('.sizeguide-step3').find('table .in').hide();
        $(this).parents('.sizeguide-step3').find('table .cm').hide();
        $(this).parents('.sizeguide-step3').find('.' + val).show();        
  });
  
  $('.sizeguide-stepper li:first-child').addClass('current');
  $('body .sizeguide-stepper li a').click(function(e){
      e.preventDefault();
      $('body .sizeguide-stepper li ').removeClass('current');
      $(this).parent().addClass('current');
      $(this).parent().nextAll().find('a').removeAttr('dt-href');
      $(this).parents('.size_chart_sec ').find('.steping_size').hide();
       // $('.size_title p strong');
      var activeTab = $(this).attr('dt-href');
      $(this).parents('.size_chart_sec').find('.steping_size[dt-id="' + activeTab + '"]').fadeIn(210);
      return false;
  });
})
// End Size Chart

$(window).on('load', function(){
  if ($(window).width() <= 767){
    $('.footer_menu .footer_menus_list ul').slideUp();
    $('.footer_menu .footer_menus_list .title').click(function(){
        $('.footer_menu .footer_menus_list ul').next().slideUp();
        $(this).next().slideToggle();
    });
  }

})

$(document).ready(function() {
  // FAQs
  $('.faq_accordian .sub_cnt').slideUp();
  $('.faq_accordian:first-child').addClass('active');
  $('.faq_accordian:first-child .sub_cnt').slideDown('active');
  $('.faq_accordian .faq_tt').click(function(){
      $(this).parents().siblings().removeClass('active');
      $(this).parents().siblings().find('.sub_cnt').slideUp();
      $(this).parents('.faq_accordian').addClass('active');
      $(this).next().slideToggle();    
  })


  
  // header Announcement bar verticle slider 
  $('.announcement_bar-slider').slick({
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    autoplay: false,
    verticalSwiping: true
  });

  // hero banner slider js 
  $('.pc--hero-slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000
  });

  // custom featured collection section js
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 2.3,
    centeredSlidesBounds: true,
    spaceBetween: 10,
    centeredSlides: true,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    breakpoints: {
      // when window width is >= 1024px
      1025: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false
      }
    }
  });

  // custom featured collection section js
  var swiper = new Swiper(".main_carousel_categories", {
    slidesPerView: 1,
    centeredSlidesBounds: true,
    spaceBetween: 10,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
    breakpoints: {
      // when window width is >= 1024px
      1025: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false
      }
    }
  });
  
  // Suitcase Slider section js
  var swiper = new Swiper(".contents_suitcase_row", {
    slidesPerView: 1.3,
    centeredSlides: true,
    spaceBetween: 100,
    freeMode: true,
    loop:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 1024px
      1025: {
        slidesPerView: 1.5,
        spaceBetween: 100,
        centeredSlides: true
      },
    }
  });
  
  // custom little gifts section js
  var swiper = new Swiper(".little_gifts_row", {
    slidesPerView: 1.3,
    centeredSlidesBounds: true,
    spaceBetween: 20,
    centeredSlides: "auto",
    freeMode: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    breakpoints: {
      // when window width is >= 1024px
      1025: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false
      },
    }
  });


  $('.image_with_text_slide_row.banner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    speed: 800,
    infinite: true,
    dots: false
  });
  
  const slideCount = $(".banner-slider .item").length;
  const indexCount = slideCount - 1;
  // console.log(indexCount);
  
  for (let i = 0; i < slideCount; i++) {
      $(".progressBarContainer").append(`
          <div class="item"><span data-slick-index="${i}" class="progressBar"></span></div>
      `);
  }
  
  // Ticking machine
  var percentTime;
  var tick;
  var time = 0.1;
  var progressBarIndex = 0;
  
  $('.progressBarContainer .progressBar').each(function (index) {
      var progress = "<div class='inProgress inProgress" + index + "'></div>";
      $(this).html(progress);
  });
  
  function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      tick = setInterval(interval, 10);
  }
  
  function interval() {
      if (($('.banner-slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
          progressBarIndex = $('.banner-slider .slick-track div[aria-hidden="false"]').data("slickIndex");
          startProgressbar();
      } else {
          percentTime += 1 / (time + 5);
          $('.inProgress' + progressBarIndex).css({
              width: percentTime + "%"
          });
  
          // Add `active` class to the current progress bar and remove it from others
          $('.progressBar').removeClass('active'); // Remove `active` class from all
          $('.progressBar[data-slick-index="' + progressBarIndex + '"]').addClass('active'); // Add `active` class to the current
  
          if (percentTime >= 100) {
              $('.image_with_text_slide_row.banner-slider').slick('slickNext');
              progressBarIndex++;
              if (progressBarIndex > indexCount) {
                  progressBarIndex = 0;
              }
              startProgressbar();
          }
      }
  }
  
  function resetProgressbar() {
      $('.inProgress').css({
          width: 0 + '%'
      });
      clearInterval(tick);
  }
  
  startProgressbar();
  // End ticking machine
  
  $('.item').click(function () {
      clearInterval(tick);
      var goToThisIndex = $(this).find("span").data("slickIndex");
      $('.image_with_text_slide_row.banner-slider').slick('slickGoTo', goToThisIndex, false);
      startProgressbar();
  });



   var gcswiper2 = new Swiper(".birthday_nav_sync_slide", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    }
  });
  var gcswiper22 = new Swiper(".birthday_nav_item_sync_slide", {
    spaceBetween: 0,
    thumbs: {
      swiper: gcswiper2
    }
  });
  gcswiper22.on("slideChangeTransitionStart", function() {
      var currentIndex = gcswiper22.realIndex;
     $('.birthday_GC_tab_data_desc').hide();
     var currentSlide = $('.birthday_GC_nav_items').eq(currentIndex);  
     var dataHref = currentSlide.attr('data-href');
     if (dataHref) {
        $(dataHref).fadeIn(); 
     }
  });

  var gcswiper3 = new Swiper(".services_nav_sync_slide", {
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    watchSlidesProgress: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    }
  });
  var gcswiper33 = new Swiper(".services_nav_item_sync_slide", {
    spaceBetween: 0,
    thumbs: {
      swiper: gcswiper3
    }
  });
  gcswiper33.on("slideChangeTransitionStart", function() {
     var currentIndex = gcswiper33.realIndex;
     $('.services_GC_tab_data_desc').hide();
     var currentSlide = $('.services_GC_nav_items').eq(currentIndex);  
     var dataHref = currentSlide.attr('data-href');
     if (dataHref) {
        $(dataHref).fadeIn(); 
     }
  });
  
  
   var gcswiper1 = new Swiper(".tips_nav_sync_slide", {
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    watchSlidesProgress: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    }
  });
  var gcswiper11 = new Swiper(".tips_nav_item_sync_slide", {
    spaceBetween: 0,
    thumbs: {
      swiper: gcswiper1
    }
  });
  gcswiper11.on("slideChangeTransitionStart", function() {
     var currentIndex = gcswiper11.realIndex;
     $('.tips_GC_tab_data_desc').hide();
     var currentSlide = $('.tips_GC_nav_items').eq(currentIndex);  
     var dataHref = currentSlide.attr('data-href');
    console.log(dataHref);
     if (dataHref) {
        $(dataHref).fadeIn(); 
     }
  });

   $('.faq_list_accordion:first-child').addClass('active');
   $('.faq_list_accordion .faq_list_desc').hide();
   $('.faq_list_accordion:first-child .faq_list_desc').show();
  $('.faq_list_accordion .faq_list_title').click(function(){
      $(this).parent().siblings().find('.faq_list_desc').slideUp();
      $(this).parent().siblings().removeClass('active');
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
  });
  
  $('.sectionNav li a[href^="#"]').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top - 140
      }, 900, 'swing', function () {
          // window.location.hash = target;
      });
  });
  
});

$(window).on('load', function(){
  $('.sr_gurantee_menu li a').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top - 140
      }, 900, 'swing', function () {
          // window.location.hash = target;
      });
  });
})


// On scroll active nav items on nav block faqs
$(document).ready(function() {
  if ($(window).width() > 1000) {
    $('.nav_menus_list_inner li:first-child').addClass('active');
    $('.nav_menus_list_inner a').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr("href");
        $('.nav_menus_list_inner a').parent().removeClass('active');
        $(this).parent().addClass('active');
        $('html, body').stop().animate({
                scrollTop: $(target).offset().top - 155
        }, 600, function() {
                // location.hash = target;
        });  
        return false;
    });
  }
});
if ($(window).width() > 1000) {
  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop();
    $('.nav_cnt').each(function(i) {
      if ($(this).position().top - 190 <= scrollDistance) {
        $('.nav_menus_list_inner li.active').removeClass('active');
        $('.nav_menus_list_inner a').eq(i).parent().addClass('active');
      }
    });
  }).scroll();
}

// Read More & Rad Less
$(document).ready(function() {
    var showChar = 80;  
    var ellipsestext = "...";
    var moretext = "see more";
    var lesstext = "see less";    

    $('.in_store_cols').each(function() {
        var content = $(this).find('.sub_cnt p').html(); 
        if(content.length > showChar) { 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar); 
            var html = c + '<span class="moreellipses">&nbsp;' + ellipsestext+ '</span><span class="morecontent"><span>' + h + '</span><a href="" class="morelink">' + moretext + '</a></span>'; 
            $(this).find('.sub_cnt ').html(html);
        } 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().css('display','none');
        $(this).hide();
        $(this).prev().css('display','inline');
        return false;
    });
});

// 
$(window).on('load', function() {
  $('.benefit_cols .of_popup').on('click', function(e) {
      var target = $(this).attr("href");
      $('html, body').stop().animate({
              scrollTop: $(target).offset().top - 300
      }, 600, function() {
              location.hash = target;
      });
  });
  
  $('.benefit_modal button,.benefit_modal_overlay').click(function(){
      $('html').removeClass('benefit_modal_open');
      $('.benefit_modal_sec ').fadeOut();
  });

  $('.benefit_details .bene_popup').click(function(e){
      e.preventDefault();
      $('html').addClass('benefit_modal_open');
      $(this).parents('.benefit_inner_list').next().fadeIn();
      return false;
  });
})


if ($(window).width() <= 1000) {
  $('.nav_menu_block_col_inner .nav_cnt').hide();
  $('.nav_menus_list ul li a').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.nav_menu_block_col_inner .nav_cnt,.page_title').fadeOut();
     
      var activeTab = $(this).attr('href');
      $(activeTab).fadeIn();
      $('.nav_menus_list').hide();
      return false;
  });
  $('.nav_crads  a').click(function(){
      $('.nav_menu_block_col_inner .nav_cnt').fadeOut();
      $('.nav_menus_list, .page_title').fadeIn();
      return false;
  });
}

$(document).ready(function() {
  if ($(window).width() <= 1000) {
     $('.ship_service_col,.refund_inner_row').addClass('owl-carousel');
     $('.ship_service_col,.refund_inner_row').owlCarousel({
        autoplay: false,
        center: true,
        loop: false,
        items: 1,
        nav: true,
        dots:false,
        navText:["<div class='owl_btn owl_prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25ZM12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25Z' fill='#1B1B1B'/><path d='M13.2603 7.71984C13.4503 7.71984 13.6403 7.78984 13.7903 7.93984C14.0803 8.22984 14.0803 8.70984 13.7903 8.99984L10.7903 11.9998L13.7903 14.9998C14.0803 15.2898 14.0803 15.7698 13.7903 16.0598C13.5003 16.3498 13.0203 16.3498 12.7303 16.0598L9.20031 12.5298C8.91031 12.2398 8.91031 11.7598 9.20031 11.4698L12.7303 7.93984C12.8803 7.78984 13.0703 7.71984 13.2603 7.71984Z' fill='#1B1B1B'/></svg></div>","<div class='owl_btn owl_next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z' fill='#1B1B1B'/><path d='M10.7397 16.2802C10.5497 16.2802 10.3597 16.2102 10.2097 16.0602C9.91969 15.7702 9.91969 15.2902 10.2097 15.0002L13.2097 12.0002L10.2097 9.00016C9.91969 8.71016 9.91969 8.23016 10.2097 7.94016C10.4997 7.65016 10.9797 7.65016 11.2697 7.94016L14.7997 11.4702C15.0897 11.7602 15.0897 12.2402 14.7997 12.5302L11.2697 16.0602C11.1197 16.2102 10.9297 16.2802 10.7397 16.2802Z' fill='#1B1B1B'/></svg></div>"],
    });
  }  
  if ($(window).width() <= 767) {
     $('.collection_icon_inner').addClass('owl-carousel');
     $('.collection_icon_inner').owlCarousel({
        autoplay: false,
        center: false,
        loop: true,
        items: 2,
        nav: false,
        dots:false,
    });
  } 

  $('.collection_item_list').addClass('owl-carousel');
  $('.collection_item_list').owlCarousel({
        autoplay: false,
        loop: true,
        items: 1,
        nav: false,
        dots:true,
  });

  // $('.colletion_product_item_inner').addClass('owl-carousel');
  // $('.colletion_product_item_inner').owlCarousel({
  //       autoplay: false,
  //       loop: false,
  //       margin: 20,
  //       items: 2.4,
  //       nav: true,
  //       dots:false,
  //       freeScroll: true,
  //       navText:['<div class="owl_btn owl_prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(0,46,94,1)"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path></svg></div>','<div class="owl_btn owl_next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="rgba(0,46,94,1)"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path></svg></div>'],
  //      responsive: {
  //       0: {
  //         items: 1.3
  //       },
    
  //       600: {
  //         items: 2.2
  //       },
    
  //       1024: {
  //         items: 2.4
  //       }
  //     }
  // });

  // var swiper = new Swiper(".tab_collection_slider", {
  //     slidesPerView: 2.3,
  //     centeredSlidesBounds: true,
  //     spaceBetween: 10,
  //     centeredSlides: true,
  //     loop: true,
  //     freeMode: true,
  //     navigation: {
  //       nextEl: ".sbu_swiper_prev1",
  //       prevEl: ".sbu_swiper_next1",
  //     },
  //     breakpoints: {
  //       // when window width is >= 1024px
  //       0: {
  //         slidesPerView: 2.2,
  //         spaceBetween: 10,
  //         centeredSlides: false
  //       },
  //       1025: {
  //         slidesPerView: 2.4,
  //         spaceBetween: 20,
  //         centeredSlides: false
  //       }
  //     }
  // });
  

  // $('.main-carousel').flickity({
  //   // options
  //   cellAlign: 'left',
  //   contain: true,
  //   freeScroll: true,
  // });

  
  $('.mt_discover_row').owlCarousel({
        autoplay: false,
        loop: false,
        margin: 20,
        items: 3,
        nav: false,
        dots:false,
        responsive: {
          0: {
            items: 1.3,
            loop: true,
          },      
          600: {
            items: 2,
            loop: false,
          },      
          992: {
            items: 3
          }
        }
  });

  $('.colletion_product_item').hide();
  $('.colletion_product_item:first-child').show();
  $('.collection_item_list').on('changed.owl.carousel', function(event) {
      var currentIndex = event.item.index;
    $('.colletion_product_item').hide();
      var currentSlide = $(this).find('.owl-item').eq(currentIndex);  
      var dataHref = currentSlide.find('.collection_item_concept').attr('data-href');
      $(dataHref).fadeIn();
  });
  
});


$(document).ready(function() {
  setTimeout(function() {
    // custom featured collection section js
    var swiper = new Swiper(".main_related-products_wrapper.mySwiper", {
      slidesPerView: 2.3,
      centeredSlidesBounds: true,
      spaceBetween: 10,
      centeredSlides: true,
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      breakpoints: {
        // when window width is >= 1024px
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false
        }
      }
    });
  }, 2500);
});

$(document).ready(function() {
  // custom featured collection section js
  var swiper = new Swiper(".cart-drawer-feature-collection .mySwiper", {
    slidesPerView: 2.3,
    centeredSlidesBounds: true,
    spaceBetween: 10,
    centeredSlides: true,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    breakpoints: {
      // when window width is >= 1024px
      1025: {
        slidesPerView: 2.3,
        spaceBetween: 20,
        centeredSlides: false
      }
    }
  });


  var swiper = new Swiper(".sub_collecion_col", {
      slidesPerView: 2.3,
      centeredSlidesBounds: true,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".sbu_swiper_next",
        prevEl: ".sbu_swiper_prev",
      },
      breakpoints: {
        // when window width is >= 1024px
        0: {
          slidesPerView: 2.2,
          spaceBetween: 10,
          centeredSlides: false
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false
        }
      }
  });



  
});

$(document).ready(function(){
  // $('.new-search-design-layout .search-modal__content .search__input.field__input').blur(function(){
  //   if(!$(this).val()){
  //     $('.wordCarousel').removeClass("error");
  //   }
  // });
  $(".new-search-design-layout .search-modal__content .search__input.field__input").focusout(function(){
    $('.wordCarousel').removeClass("error");
  });
  $(".new-search-design-layout .search-modal__content .search__input.field__input").keydown(function(){
    $('.wordCarousel').addClass("error");
  });
  $(".new-search-design-layout .search-modal__content .search__input.field__input").keyup(function(){
    $('.wordCarousel').addClass("error");
  });
});

// 24-01-2025


$(document).ready(function() {
  $("ul.product-metafield-product li img").mouseover(function(){
    var product_name = $(this).attr("data-value");
    $(this).parents(".product-metafield-product-wrapper").find(".product-variant-name span").text(product_name);
  });
});

// document.querySelector(".video-section__poster").addEventListener("click", function() {
//             var iframe = document.querySelector(".js-vimeo");
//             var iframeSrc = iframe.src;
//             iframe.src = ""; // Temporarily clear the src
//             iframe.src = iframeSrc; // Reset it to the original src, which will play the video
//         });








